export class faqs {

	/*
	 * Init the handler
	 *
	 */
    constructor() {
		// For FAQs in FAQ page template 
		const faqTitles = document.querySelectorAll('.faq-title');
		const Questions = document.querySelectorAll('.faq-item');

		faqTitles.forEach((faq) => {
			faq.addEventListener('click', this.changeFaqSection.bind(this, faq))
		});

		Questions.forEach((question) => {
			question.addEventListener('click', this.toggleQuesiton.bind(this, question))
		})
    }

	 /*
	 * Gets selected ID for selected section
	 * 
	 * @param     {self} the selected element
	 * @param     {e} the click event
	 * @return    {void}
	 */
	changeFaqSection(self, e) {
		e.preventDefault();
		
		let id = self.getAttribute('data-id')
		this.updateFaqSection(id, self);
	}

	/*
	 * Sets active class for active section
	 * 
	 * @param     {id} id of active section
	 * @return    {void}
	 */
	updateFaqSection(id) {
		let this_section = document.getElementById(id)

		document.querySelectorAll('.faq-title').forEach(el => {
			el.classList.remove('faq-title__active');
			if(el.getAttribute('data-id') === id) {
				el.classList.add('faq-title__active');
			}	
		});

		// Remove active class from other sections 
		document.querySelectorAll('.faq-section').forEach((el) => el.classList.remove('faq-section__active'))
		// Add active class to section
		this_section.classList.add('faq-section__active');
	}

	 /*
	 * Toggles FAQ item to open and close
	 *
	 * @return    {void}
	 */
	toggleQuesiton(self) {
		const alreadyOpen = self.classList.contains('faq-item__active');
		// Add active class to FAQ item
		if (alreadyOpen) {
			self.classList.remove('faq-item__active');
		} else {
			self.classList.add('faq-item__active');
		}
	}

}